import { brandColors } from '@prisjakt/ui-base';
import styled from 'styled-components';
import ExpertIconComponent from '../../../../components/prisjakt-icon';

export const ExpertAvatar = styled.div`
  position: relative;
  height: fit-content;
`;

export const ExpertIcon = styled(ExpertIconComponent).attrs({
  color: brandColors.expert,
})`
  position: absolute;
  bottom: 0;
  right: 0;
`;
